import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { defineComponent, inject } from "vue";
import RegistrationHeader from "./RegistrationHeader.class";
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>("incentiveV2Store");
		if(!store) {
			throw new Error("incentiveV2Store not provided");
		}
		const component = new RegistrationHeader(store);
		return setupComponent(component);
	},
});
